import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Powitanie from './header';
import Cards from './card';
import ButtonMsg from './ButtonMsg';
import 'bootstrap/dist/css/bootstrap.min.css';

const gry = [
  ["Minecraft", "Gra survivalowa w otwartym świecie."],
  ["Cyberpunk 2077", "RPG w klimacie sci-fi."],
  ["The Witcher 3: Wild Hunt", "Epickie RPG osadzone w świecie fantasy."],
  ["Elden Ring", "Trudna gra akcji z otwartym światem."],
  ["GTA V", "Sandbox z fabułą pełną akcji i swobody."],
  ["Red Dead Redemption 2", "Westernowa gra akcji z ogromnym światem."],
  ["Fortnite", "Dynamiczna gra battle royale."],
  ["League of Legends", "Popularna gra MOBA 5v5."],
  ["Valorant", "Taktyczny FPS od Riot Games."],
  ["Apex Legends", "Szybki battle royale z bohaterami."],
  ["Stardew Valley", "Relaksująca gra o prowadzeniu farmy."],
  ["Hades", "Roguelike z dynamiczną walką i świetną fabułą."],
  ["Among Us", "Towarzyska gra dedukcyjna o znajdowaniu oszusta."],
  ["Terraria", "Sandbox 2D z eksploracją i craftingiem."],
  ["Assassin's Creed Valhalla", "Gra akcji w czasach wikingów."],
  ["Overwatch 2", "Hero shooter z drużynową rozgrywką."],
  ["FIFA 24", "Popularna gra piłkarska."],
  ["The Last of Us Part II", "Filmowa gra akcji z mocną historią."],
  ["Skyrim", "RPG fantasy z ogromnym światem do eksploracji."],
  ["Call of Duty: Modern Warfare II", "FPS z kampanią i trybem online."]
];


function App() {
  
  const [szukaj, setSzukaj] = useState("");

  const filtrowaneGry = gry.filter(gra =>
    gra[0].toLowerCase().includes(szukaj.toLowerCase())
  );

  return (
    <>
      <Powitanie />

      <div className="container py-4">

        <ButtonMsg />

        <input
          type="text"
          placeholder="Szukaj gry..."
          className="form-control mt-4 mb-3"
          value={szukaj}
          onChange={(e) => setSzukaj(e.target.value)}
        />

        <div className="row">
          {filtrowaneGry.map((gra, index) => (
            <Cards key={index} tytul={gra[0]} opis={gra[1]} />
          ))}
        </div>
      </div>
    </>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App/>
);

reportWebVitals();
